export const DEVBOX_PATHS = {
  root: '/devbox-manager',
  apiKeys: '/devbox-manager/api-keys',
} as const;

export const DEVBOX_SUBMENU_ITEMS = [
  { title: 'API Keys', to: DEVBOX_PATHS.apiKeys },
] as const;
